export const globalClasses = {
  active: '.Mui-active',
  checked: '.Mui-checked',
  completed: '.Mui-completed',
  disabled: '.Mui-disabled',
  error: '.Mui-error',
  expanded: '.Mui-expanded',
  focusVisible: '.Mui-focusVisible',
  focused: '.Mui-focused',
  readOnly: '.Mui-readOnly',
  required: '.Mui-required',
  selected: '.Mui-selected',
  MuiLinearProgressBar: '.MuiLinearProgress-bar',
  MuiLinearProgressBarRoot: '.MuiLinearProgress-root',
  typographyRoot: '.MuiTypography-root',
  listRoot: '.MuiList-root',
  autocompletePaper: '.MuiAutocomplete-paper',
  autocompleteListbox: '.MuiAutocomplete-listbox',
  checkboxRoot: '.MuiCheckbox-root',
  boxRoot: '.MuiBox-root',
  menuItem: '.MuiMenuItem-root',
  buttonStartIcon: '.MuiButton-startIcon',
  svgIconRoot: '.MuiSvgIcon-root',
  selectIcon: '.MuiSelect-icon',
  selectIconOpen: '.MuiSelect-iconOpen',
  inputBase: '.MuiInputBase-input',
  outlinedInputLine: '.MuiOutlinedInput-notchedOutline',
  modalContent: '.MuiPaper-root',
  tabIndicator: '.MuiTabs-indicator',
  chipAvatar: '.MuiChip-avatar',
  chipLabel: '.MuiChip-label',
  textFieldRoot: '.MuiOutlinedInput-root',
  textFieldLabel: '.MuiFormLabel-root',
  textFieldFieldset: 'fieldset',
} as const;
